/**
 *
 *  Header
 *  DateTimePicker
 *
 *  Created by Vladimir Shishlyannikov on 12/03/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React from "react";
import PropTypes from "prop-types"; // use directly

const Header = ({ label, labelId, onViewChange, isRtl }) => {
  return (
    <div className="tb-calendar-header tbk-mb-3 tbk-flex tbk-justify-between">
      <div className="tb-calendar-header-text tbk-text-cta tbk-text-blue-dark">
        Select date
      </div>
      <div className="tb-calendar-btns">
        <span
          id={labelId}
          onClick={onViewChange}
          className="tbk-text-main tbk-uppercase tbk-text-blue-dark"
          aria-live="polite"
          aria-atomic="true"
        >
          <span>{label}</span>
        </span>
      </div>
    </div>
  );
};

Header.propTypes = {
  label: PropTypes.string.isRequired,
  labelId: PropTypes.string,

  onViewChange: PropTypes.func, //.isRequired,
  // isRtl: PropTypes.bool,
};

export default Header;
